import { render, staticRenderFns } from "./IconModal.vue?vue&type=template&id=785447c7&scoped=true&"
import script from "./IconModal.vue?vue&type=script&lang=js&"
export * from "./IconModal.vue?vue&type=script&lang=js&"
import style0 from "./IconModal.vue?vue&type=style&index=0&id=785447c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785447c7",
  null
  
)

export default component.exports